<template>
  <div class="dashboard-section">
    <h1>{{ title }}</h1>
    <slot />
  </div>
</template>

<script>
export default {
  name: "DashboardSection",
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-section {
  margin-bottom: 20px;
}
</style>
